/*
 * @flow
 */
import { getParam } from '../util';
import type Orchestrator from '../orchestrator';

export function getReadyState() {
  return document.readyState;
}

export default function triggerOpen(orc: Orchestrator) {
  // trigger open checkout widget
  const triggeredSlug: ?string = getParam('unii-trigger-open');
  if (triggeredSlug) {
    // open Checkout widget only when document is ready
    if (getReadyState() !== 'loading') {
      orc.showCheckout(triggeredSlug);
    }

    else {
      document.addEventListener('DOMContentLoaded', () => {
        orc.showCheckout(triggeredSlug);
      }, false);
    }
  }
}



// WEBPACK FOOTER //
// ./src/bootstrap/plugins/triggerOpen.js